// @flow
import React from 'react'
import styled from 'styled-components'
import media from '../../../../styles/media'
import Button from '../../../../components/Button'

const Component = styled.div`
  text-align: center;
  width: 80%;
  margin: 0 auto 3rem auto;
`

const Image = styled.img`
  width: 200px;
  height: 200px;
  margin-bottom: 1.5rem;
`

const TitlesRow = styled.div`
  height: 50px;
  margin-bottom: 1.5rem;
`

const Bio = styled.div`
  margin-bottom: 1.5rem;
  ${media.lgUp} {
    height: 140px;
  }
`

type Props = {
  name: string,
  titles: array,
  image: string,
  email: string,
  openContactModal: func,
  bio: string
}

const Agent = ({
  name,
  titles,
  image,
  email,
  bio,
  openContactModal
}: Props) => (
  <Component>
    {image && <Image src={image} alt={name} />}
    <h4>{name}</h4>
    <TitlesRow>
      <div style={{ textTransform: 'uppercase' }}>{titles[0]}</div>
      {!!titles[1] && (
        <div style={{ textTransform: 'uppercase' }}>{titles[1]}</div>
      )}
    </TitlesRow>
    <Bio>{bio}</Bio>
    <Button
      color="primary"
      onClick={() => openContactModal({ to: email })}
      style={{ width: '200px' }}
    >
      {`Contact ${name.split(' ')[0]}`}
    </Button>
  </Component>
)

export default Agent



// WEBPACK FOOTER //
// ./src/views/Agents/components/Agent/index.js